import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './langs/index'
import elementUI from 'element-ui';

Vue.use(VueI18n)
console.log('messages=',messages)

const i18n = new VueI18n({
  locale: localStorage.getItem("language"),
  messages
})

Vue.use(elementUI, {
    i18n: (key, value) => i18n.t(key, value)
})

export default i18n